import React from 'react'
import { css } from 'glamor'
import Subscribe from '../subscribe'
import colors from '../../style/colors'
import { fontWeight } from '../../style/sizes'
import toriiLogo from '../../assets/logo_white.svg'

const CSS = {
  main: css({
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: colors.blue,
    backgroundImage: 'radial-gradient(circle at left, #0054FF 0%, #1A31AE 100%)',
    padding: 0,
    marginTop: '250px'
  }),
  curated: css({
    color: colors.white,
    textAlign: 'center',
    margin: '-30px 0 80px 0',
    fontSize: '17px',
    fontWeight: fontWeight.semiBold,
    ' > a': {
      color: colors.white,
      borderBottom: `1px solid ${colors.white}`
    }
  }),
  footer: css({
    height: '60px',
    backgroundColor: 'rgba(255, 255, 255, 0.13)',
    ' > div': {
      display: 'flex',
      width: '828px',
      maxWidth: '90%',
      margin: 'auto',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: '100%'
    }
  }),
  privacy: css({
    color: colors.lightBlue1,
    fontSize: '14px'
  })
}

const Footer = () => (
  <div {...CSS.main}>
    <Subscribe />
    <div {...CSS.curated}>Curated with <span style={{ color: colors.cyan }}>❤</span> by <a href='https://toriihq.com'>Torii</a></div>
    <footer {...CSS.footer}>
      <div>
        <a href='https://toriihq.com'><img src={toriiLogo} alt='Torii' /></a>
        <a href='https://toriihq.com/privacy' {...CSS.privacy}>Privacy policy</a>
      </div>
    </footer>
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/index.js